/** localStorage: last whatsNew entry id for which the user dismissed the mini teaser or opened full detail */
export const INVOICE_WHATSNEW_TEASER_SUPPRESSED_ENTRY_ID =
  'fordeer_invoice_whatsnew_teaser_suppressed_entry_id'

export const INVOICE_WHATSNEW_LIST_MAX_ITEMS = 2
